import { MenuItem } from "@/app/lib/features/menus/menus.types";
import { cn } from "@/app/utils/cn";
import { ChevronRight } from "lucide-react";
import { FC } from "react";
import FallbackImage from "../FallbackImage";
import Link from "next/link";
import { trackInteraction } from "@/app/lib/tracking/interactions";

interface CategoriesButtonProps {
  category: MenuItem;
  active: boolean;
  onClose?: () => void;
}

const CategoriesButton: FC<CategoriesButtonProps> = ({ category, active, onClose }) => {
  return (
    <Link
      href={`/${category.url}`}
      onClick={() => { trackInteraction("menu", category.id, "click"); onClose?.(); }}
      className={cn(
        "flex items-center justify-between text-sm font-semibold py-4 px-3 cursor-pointer transition-all duration-300 ease-in-out",
        active ? "bg-white text-main" : "bg-muted text-gray-800 hover:bg-white",
      )}
    >
      <div className="flex items-center gap-2">
        {category.icon && (
          <div className="w-5 h-5 relative shrink-0">
            <FallbackImage
              src={category.icon}
              alt={category.name}
              width={19}
              height={19}
              className="object-contain"
            />
          </div>
        )}
        <span className="capitalize">{category.name}</span>
        {category.is_new && (
          <span className="text-[10px] font-bold text-white bg-red-500 rounded px-1 py-0.5 leading-none">
            Yeni
          </span>
        )}
        {category.badge_text && (
          <span className="text-[10px] font-bold text-white bg-main rounded px-1 py-0.5 leading-none">
            {category.badge_text}
          </span>
        )}
      </div>
      <ChevronRight
        size={16}
        className={cn(active ? "text-main" : "text-gray-600")}
      />
    </Link>
  );
};

export default CategoriesButton;
